import React, { useState, useEffect } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import file from '../../assets/files/National-ThaiWater-User-Manual.pdf';

const PDFViewer = () => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [defaultScale, setDefaultScale] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      const { innerWidth } = window;
      let scale = 1;

      // Adjust these values based on your needs
      if (innerWidth <= 600) {
        scale = 0.5; // Mobile devices
      } else if (innerWidth <= 1024) {
        scale = 0.8; // Tablets
      }

      setDefaultScale(scale);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div style={{ height: '100vh' }}>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
        <Viewer
          fileUrl={file}
          plugins={[defaultLayoutPluginInstance]}
          defaultScale={defaultScale}
        />
      </Worker>
    </div>
  );
};

export default PDFViewer;
